// assets/video-popup.js 修正版
!function(){"use strict";
  const e = "data-video-play";
  
  customElements.get("video-popup") || customElements.define("video-popup", class extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.querySelectorAll(`[${e}]`)?.forEach((t => {
        t.addEventListener("click", (t => {
          const n = t.currentTarget;
          if ("" !== n.getAttribute(e).trim()) {
            t.preventDefault();
            
            // カスタムポップアップを作成（PhotoSwipeの代わりに）
            this.createCustomVideoPopup(n.getAttribute(e));
            window.a11y.lastElement = n;
          }
        }));
      }));
    }
    
    // カスタム動画ポップアップを作成
    createCustomVideoPopup(videoHtml) {
      // 既存のポップアップを削除
      const existingPopup = document.querySelector('.custom-video-popup');
      if (existingPopup) {
        existingPopup.remove();
      }
      
      // ポップアップ要素を作成
      const popup = document.createElement('div');
      popup.className = 'custom-video-popup';
      popup.innerHTML = `
        <div class="video-popup-overlay"></div>
        <div class="video-popup-container">
          <button class="video-popup-close pswp__custom-close" aria-label="Close video">
            <span class="icon" aria-hidden="true">×</span>
          </button>
          <div class="video-popup-content">
            ${videoHtml}
          </div>
        </div>
      `;
      
      document.body.appendChild(popup);
      document.body.style.overflow = 'hidden';
      
      // 動画要素を取得して設定を適用
      const video = popup.querySelector('video');
      if (video) {
        // 3. モーダルの自動ループをなくす（最優先）
        video.loop = false;
        video.removeAttribute('loop');
        
        // 動画終了時の処理
        video.addEventListener('ended', function() {
          this.pause();
          this.currentTime = this.duration;
        });
        
        // 1. モーダル開いた時にオーバーレイ再生コントロールを消す（最優先）
        if (window.innerWidth <= 767) {
          // 最初からコントロールを完全に非表示
          video.removeAttribute('controls');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          
          // 再生開始時にコントロールを強制非表示
          video.addEventListener('loadstart', function() {
            this.removeAttribute('controls');
          });
          
          video.addEventListener('loadedmetadata', function() {
            this.removeAttribute('controls');
          });
          
          // タップ時のみ短時間表示（1.5秒間）
          video.addEventListener('touchstart', function() {
            video.classList.add('show-controls');
            setTimeout(() => {
              video.classList.remove('show-controls');
            }, 1500);
          });
          
          // ダブルタップでも同様
          video.addEventListener('click', function() {
            video.classList.add('show-controls');
            setTimeout(() => {
              video.classList.remove('show-controls');
            }, 1500);
          });
        }
        
        // 動画を再生
        video.play().catch(console.error);
      }
      
      // 閉じるイベント
      const closeBtn = popup.querySelector('.video-popup-close');
      const overlay = popup.querySelector('.video-popup-overlay');
      
      const closePopup = () => {
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        popup.remove();
        document.body.style.overflow = '';
      };
      
      closeBtn.addEventListener('click', closePopup);
      overlay.addEventListener('click', closePopup);
      
      // ESCキーで閉じる
      const escHandler = (e) => {
        if (e.key === 'Escape') {
          closePopup();
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
      
      // ポップアップ表示アニメーション
      requestAnimationFrame(() => {
        popup.classList.add('show');
      });
    }
  });
}();